var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7925 9.95663L20.7926 9.95673C20.963 10.1261 21.0981 10.3276 21.19 10.5496C21.282 10.7716 21.3289 11.0096 21.3281 11.2499V11.25V20.25C21.3281 20.536 21.2145 20.8102 21.0124 21.0124C20.8102 21.2146 20.5359 21.3282 20.25 21.3282H3.75001C3.46407 21.3282 3.18985 21.2146 2.98766 21.0124C2.78547 20.8102 2.67188 20.536 2.67188 20.25L2.67188 11.25L2.67188 11.2499C2.67111 11.0096 2.71805 10.7716 2.80999 10.5496C2.90192 10.3276 3.03701 10.1261 3.20743 9.95673L3.20753 9.95663L10.7075 2.45664C10.7075 2.45664 10.7075 2.45663 10.7075 2.45663C11.0504 2.11391 11.5153 1.92139 12 1.92139C12.4848 1.92139 12.9497 2.11391 13.2925 2.45663C13.2925 2.45663 13.2925 2.45664 13.2925 2.45664L20.7925 9.95663ZM19.125 19.1719H19.1719V19.125V11.4047V11.3853L19.1582 11.3716L12.0332 4.24659L12 4.21345L11.9669 4.24659L4.84186 11.3716L4.82813 11.3853V11.4047V19.125V19.1719H4.87501H19.125Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 0.09375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dff7c47987c0fe99b41240effdc848fc.svg";
export { ForwardRef as ReactComponent };